// src/theme-provider.tsx
import React from "react";
import { createGlobalStyle } from "styled-components";

// src/tenants-theme.ts
var tenantsNames = {
  default: "default",
  intraser: "intraser",
  xpo: "xpo",
  rpt: "rpt",
  cex: "cex",
  ontime: "ontime",
  alianza: "alianza"
};
var tenantsThemeGlobalVariables = {
  [tenantsNames.default]: `
    :root {
      // login
      --login-button-bg-hover: hsl(207 100% 35%);
      --login-button-bg: #0071CE;
      --login-logo-width: 122px;

      // authorization
      --ntk-authorization-button-background-hover: var(--login-button-bg-hover);
      --ntk-authorization-button-background: var(--login-button-bg);
      --ntk-authorization-logo-width: var(--login-logo-width);

      // primary top-bar
      --primary-top-bar: #0071CE;
      --primary-filters: #1F55AD;
      --primary-top-bar-color: #E2E8EE;
      --primary-top-bar-border: 1px solid #1F55AD;

      //general
      --button-primary-bg: #01309a;
      --accent-color-blue: #0071CE;

      // theme
      --otk-theme-font-color: #182a33;
      --otk-theme-color-blue-900: #000512;
      --otk-theme-color-blue-800: #001037;
      --otk-theme-color-blue-700: #001b5b;
      --otk-theme-color-blue-600: #002580;
      --otk-theme-color-blue-500: #0030a4;
      --otk-theme-color-blue-400: #4e84fe;
      --otk-theme-color-blue-300: #80a7fe;
      --otk-theme-color-blue-200: #b3caff;
      --otk-theme-color-blue-100: #e6edff;
      --otk-theme-color-grey-100: #f2f5f8;
      --otk-theme-color-grey-200: #e2e8ee;
      --otk-theme-color-grey-300: #ccd6e0;
      --otk-theme-color-grey-400: #b3bfcc;
      --otk-theme-color-grey-500: #94A6B8;
      --otk-theme-color-grey-600: #758ca3;
      --otk-theme-color-grey-700: #54708C;
      --otk-theme-color-grey-800: #47596b;
      --otk-theme-color-grey-900: #263340;
      --otk-theme-color-grey: var(--otk-theme-color-grey-500);
      --otk-theme-color-grey-hover: var(--otk-theme-color-grey-700);
      --otk-theme-color-grey-disabled: var(--otk-theme-color-grey-200);
      --otk-theme-color-ghost: var(--otk-theme-color-grey-100);
      --otk-theme-color-primary: var(--otk-theme-color-primary-500);
      --otk-theme-color-primary-ghost: var(--otk-theme-color-primary-100);
      --otk-theme-color-primary-soft: var(--otk-theme-color-primary-200);
      --otk-theme-color-primary-soft-hover: var(--otk-theme-color-primary-300);
      --otk-theme-color-primary-soft-disabled: var(--otk-theme-color-primary-100);
      --otk-theme-color-primary-hover: var(--otk-theme-color-primary-600);
      --otk-theme-color-primary-disabled: var(--otk-theme-color-primary-200);
      --otk-theme-border-radius: 0;
      --otk-theme-border-radius-s: 0;
      --otk-theme-border-color: var(--otk-theme-color-grey-500);
      --otk-theme-border: 1px solid var(--otk-theme-border-color);

      // -- buttons
      --otk-ui-button-border-radius: 0;
      --otk-ui-button-primary-soft-color: var(--otk-theme-color-primary-400);
      --otk-ui-button-primary-soft-hover-color: var(--otk-theme-color-primary-500);

      // -- inputs

      --otk-ui-input-height: 35px;
      --otk-ui-input-padding: var(--otk-theme-space-m) var(--otk-theme-space-xs) var(--otk-theme-space-m) var(--otk-theme-space-xs);


      // -- table

      // ---- header
      --otk-ui-table-header-background:  var(--otk-theme-color-grey-200);
      --otk-ui-table-header-cell-border-right: none;
      --otk-ui-table-header-cell-text-color: var(--otk-theme-color-grey-grey-700);

      // ---- pagination
      --otk-ui-table-pagination-element-is-selected-background: var(--primary-top-bar);
      --otk-ui-table-pagination-element-border-radius: none;
      --otk-ui-table-pagination-element-color: var(--otk-theme-font-color);
    }`,
  [tenantsNames.intraser]: `
    :root {
      // login
      --login-button-bg-hover: hsl(207 100% 35%);
      --login-button-bg: #0071CE;
      --login-logo-width: 122px;

      // authorization
      --ntk-authorization-button-background-hover: var(--login-button-bg-hover);
      --ntk-authorization-button-background: var(--login-button-bg);
      --ntk-authorization-logo-width: var(--login-logo-width);

      // primary top-bar
      --primary-top-bar: #0071CE;
      --primary-filters: #1F55AD;
      --primary-top-bar-color: #E2E8EE;
      --primary-top-bar-border: 1px solid #1F55AD;
      --button-primary-bg: #01309a;

      //general
      --accent-color-blue: #0071CE;
    }`,
  [tenantsNames.xpo]: `
    :root {
      //login
      --login-button-bg-hover: hsl(0 100% 30%);
      --login-button-bg: #C00;
      --login-logo-width: 200px;

      // authorization
      --ntk-authorization-button-background-hover: var(--login-button-bg-hover);
      --ntk-authorization-button-background: var(--login-button-bg);
      --ntk-authorization-logo-width: var(--login-logo-width);

      // primary top-bar
      --primary-top-bar: #FFF;
      --primary-top-bar-color: #2396DC;
      --primary-top-bar-border: 1px solid #E2E8EE;
      --primary-top-bar-logo-margin-top: 0;
      --primary-top-bar-logo-padding: 6px 0;
      --button-primary-bg: #2396DC;

      // -- input
      --otk-ui-input-height: 40px;
      --otk-ui-input-padding: var(--otk-theme-space-xs) var(--otk-theme-space-s) var(--otk-theme-space-2xs);
    }

    body {
      background-color: #fff !important;
    }`,
  [tenantsNames.rpt]: `
    :root {
      // login
      --login-button-bg-hover: hsl(200, 71%, 53%);
      --login-button-bg: #57B1E5;
      --login-logo-width: 150px;

      // authorization
      --ntk-authorization-button-background-hover: var(--login-button-bg-hover);
      --ntk-authorization-button-background: var(--login-button-bg);
      --ntk-authorization-logo-width: var(--login-logo-width);

      // primary top-bar
      --primary-top-bar: #FFF;
      --primary-top-bar-color: #2396DC;
      --primary-top-bar-border: 1px solid #E2E8EE;
      --primary-top-bar-logo-margin-top: 0;
      --primary-top-bar-logo-padding: 5px 0;
      --button-primary-bg: #2396DC;
    }

    body {
      background-color: #fff !important;
    }`,
  [tenantsNames.ontime]: `
    :root {
      // tenant theme
      --otk-theme-color-blue-100: #6F94E9;
      --otk-theme-color-blue-200: #5782E6;
      --otk-theme-color-blue-300: #3F70E2;
      --otk-theme-color-blue-400: #275EDF;
      --otk-theme-color-blue-500: #0F4CDB;
      --otk-theme-color-blue-600: #0E44C5;
      --otk-theme-color-blue-700: #0C3DAF;
      --otk-theme-color-blue-800: #0B3599;
      --otk-theme-color-blue-900: #092E83;
      --otk-theme-color-primary-100: var(--otk-theme-color-blue-100);
      --otk-theme-color-primary-200: var(--otk-theme-color-blue-200);
      --otk-theme-color-primary-300: var(--otk-theme-color-blue-300);
      --otk-theme-color-primary-400: var(--otk-theme-color-blue-400);
      --otk-theme-color-primary-500: var(--otk-theme-color-blue-500);
      --otk-theme-color-primary-600: var(--otk-theme-color-blue-600);
      --otk-theme-color-primary-700: var(--otk-theme-color-blue-700);
      --otk-theme-color-primary-800: var(--otk-theme-color-blue-800);
      --otk-theme-color-primary-900: var(--otk-theme-color-blue-900);
      --otk-theme-color-primary: var(--otk-theme-color-primary-400);
      --otk-theme-color-primary-ghost: var(--otk-theme-color-primary-100);
      --otk-theme-color-primary-soft: var(--otk-theme-color-primary-200);
      --otk-theme-color-primary-soft-hover: var(--otk-theme-color-primary-300);
      --otk-theme-color-primary-soft-disabled: var(--otk-theme-color-primary-100);
      --otk-theme-color-primary-hover: var(--otk-theme-color-primary-500);
      --otk-theme-color-primary-disabled: var(--otk-theme-color-primary-100);

      // login
      --login-button-bg-hover: var(--otk-theme-color-primary-hover);
      --login-button-bg: var(--otk-theme-color-primary);
      --login-logo-width: 150px;

      // authorization
      --ntk-authorization-button-background-hover: var(--login-button-bg-hover);
      --ntk-authorization-button-background: var(--login-button-bg);
      --ntk-authorization-logo-width: var(--login-logo-width);

      // primary top-bar
      --primary-top-bar: #FFF;
      --primary-top-bar-color:var(--otk-theme-color-primary);
      --primary-top-bar-border: var(--otk-theme-border);
      --primary-top-bar-logo-margin-top: 0;
      --primary-top-bar-logo-padding: 5px 0;
      --button-primary-bg: var(--otk-theme-color-primary);

      // ui components

      // -- icons
      --otk-ui-icon-primary-color: var(--otk-theme-color-primary);
      --otk-ui-icon-secondary-color: var(--otk-theme-color-secondary);

      // table pagination
      --otk-ui-table-pagination-height: 70px;
    }

    body {
      background-color: #fff !important;
    }`,
  [tenantsNames.cex]: `
    :root {
      // login
      --login-bg-color: #00204d;
      --login-button-color: #00204d;
      --login-button-bg-hover: var(--otk-theme-color-yellow-500);
      --login-button-bg: var(--otk-theme-color-yellow-400);
      --login-logo-width: 122px;

      // authorization
      --ntk-authorization-button-background-hover: var(--login-button-bg-hover);
      --ntk-authorization-button-background: var(--login-button-bg);
      --ntk-authorization-logo-width: var(--login-logo-width);
      --ntk-authorization-title-color: var(--otk-theme-color-primary);

      //general
      --button-primary-bg: var(--otk-theme-color-yellow-400);

      // primary top-bar
      --primary-top-bar: #fff;
      --primary-top-bar-border: var(--otk-theme-border);
      --primary-top-bar-logo-margin: 0;
      --primary-top-bar-logo-margin-top: 0;
      --primary-top-bar-logo-padding: 10px 10px;
      --primary-top-bar-logo-background: #00204d;
      --primary-top-bar-submenu-icon: var(--button-primary-bg);
      --primary-top-bar-submenu-icon-hover: var(--otk-theme-color-yellow-500);

      // tenant theme
      --otk-theme-color-blue-100: #b3d2ff;
      --otk-theme-color-blue-200: #80b5ff;
      --otk-theme-color-blue-300: #4d97ff;
      --otk-theme-color-blue-400: #1a79ff;
      --otk-theme-color-blue-500: #0060e6;
      --otk-theme-color-blue-600: #004bb3;
      --otk-theme-color-blue-700: #002e6e;
      --otk-theme-color-blue-800: #00204d;
      --otk-theme-color-blue-900: #00183b;
      --otk-theme-color-primary-100: var(--otk-theme-color-yellow-100);
      --otk-theme-color-primary-200: var(--otk-theme-color-yellow-200);
      --otk-theme-color-primary-300: var(--otk-theme-color-yellow-300);
      --otk-theme-color-primary-400: var(--otk-theme-color-yellow-400);
      --otk-theme-color-primary-500: var(--otk-theme-color-yellow-500);
      --otk-theme-color-primary-600: var(--otk-theme-color-yellow-600);
      --otk-theme-color-primary-700: var(--otk-theme-color-yellow-700);
      --otk-theme-color-primary-800: var(--otk-theme-color-yellow-800);
      --otk-theme-color-primary-900: var(--otk-theme-color-yellow-900);
      --otk-theme-color-primary: var(--otk-theme-color-primary-400);
      --otk-theme-color-primary-ghost: var(--otk-theme-color-primary-100);
      --otk-theme-color-primary-soft: var(--otk-theme-color-primary-200);
      --otk-theme-color-primary-soft-hover: var(--otk-theme-color-primary-300);
      --otk-theme-color-primary-soft-disabled: var(--otk-theme-color-primary-100);
      --otk-theme-color-primary-hover: var(--otk-theme-color-primary-500);
      --otk-theme-color-primary-disabled: var(--otk-theme-color-primary-100);
      --otk-theme-color-secondary-900: var(--otk-theme-color-blue-900);
      --otk-theme-color-secondary-800: var(--otk-theme-color-blue-800);
      --otk-theme-color-secondary-700: var(--otk-theme-color-blue-700);
      --otk-theme-color-secondary-600: var(--otk-theme-color-blue-600);
      --otk-theme-color-secondary-500: var(--otk-theme-color-blue-500);
      --otk-theme-color-secondary-500: var(--otk-theme-color-blue-500);
      --otk-theme-color-secondary-400: var(--otk-theme-color-blue-400);
      --otk-theme-color-secondary-300: var(--otk-theme-color-blue-300);
      --otk-theme-color-secondary-200: var(--otk-theme-color-blue-200);
      --otk-theme-color-secondary-100: var(--otk-theme-color-blue-100);
      --otk-theme-color-secondary: var(--otk-theme-color-blue-800);
      --otk-theme-border-radius: 0;
      --otk-theme-border-radius-s: 0;
      --otk-theme-border-color: var(--otk-theme-color-grey-400);

      // ui components

      // buttons
      --otk-ui-button-primary-color: var(--otk-theme-color-blue-800);
      --otk-ui-button-primary-disabled-color: var(--otk-theme-color-blue-100);
      --otk-ui-button-primary-hover-color: var(--otk-theme-color-blue-900);
      --otk-ui-button-primary-outline-color: var(--otk-theme-color-secondary);
      --otk-ui-button-primary-outline-hover-color: var(--otk-theme-color-secondary-hover);

      // -- icons
      --otk-ui-icon-primary-color: var(--otk-theme-color-secondary);
      --otk-ui-icon-secondary-color: var(--otk-theme-color-primary);

      // -- checkbox
      --otk-ui-checkbox-border: 2px solid var(--otk-theme-border-color);
      --otk-ui-checkbox-is-checked-background-color: var(--otk-theme-color-grey-600);
      --otk-ui-checkbox-is-checked-border-color: var(--otk-theme-color-grey-600);
      --otk-ui-checkbox-is-checked-after-width: 6px;
      --otk-ui-checkbox-is-checked-after-height: 14px;
      --otk-ui-checkbox-is-checked-after-top: -1px;
      --otk-ui-checkbox-is-checked-after-left: 5px;
      --otk-ui-checkbox-is-hover-border-color: var(--otk-theme-color-grey-600);
      --otk-ui-checkbox-disabled-background-color: var(--otk-theme-color-grey-100);
      --otk-ui-checkbox-disabled-border-color: var(--otk-theme-color-grey-300);

      --otk-ui-checkbox-primary-is-checked-background-color: var(--otk-theme-color-primary);
      --otk-ui-checkbox-primary-is-checked-border-color: var(--otk-theme-color-primary);

       // -- radio
      --otk-ui-radio-gap: 8px;
      --otk-ui-radio-size: 20px;
      --otk-ui-radio-border: 2px solid var(--otk-theme-border-color);
      --otk-ui-radio-border-radius: var(--otk-theme-border-radius-s);
      --otk-ui-radio-is-checked-dot-size: 8px;
      --otk-ui-radio-is-checked-background-color: var(--otk-theme-color-primary);
      --otk-ui-radio-is-checked-dot-color: var(--otk-theme-color-white);

      // -- table
      --otk-ui-table-row-height: 70px;
      --otk-ui-table-row-accordion-parent-min-height: 70px;
      --otk-ui-table-row-accordion-parent-cell-icon-background-color: var( --otk-theme-color-grey-300);
      --otk-ui-table-row-accordion-child-height: 50px;
      --otk-ui-table-row-accordion-child-cell-icon-background-color: var(--otk-theme-color-grey-200);

      // -- datepicker
      --otk-ui-datepicker-border: none;
      --otk-ui-datepicker-navigation-next-border-left-color: var(--otk-theme-color-grey-700);
      --otk-ui-datepicker-navigation-next-hover-border-left-color: var(--otk-theme-color-grey-800);
      --otk-ui-datepicker-header-background-color: none;
      --otk-ui-datepicker-header-border-bottom: none;
      --otk-ui-datepicker-header-border-top-left-radius: 0;
      --otk-ui-datepicker-header-border-top-right-radius: 0;
      --otk-ui-datepicker-header-padding-top: 0;
      --otk-ui-datepicker-current-month-color: var(--otk-theme-color-grey-700);;
      --otk-ui-datepicker-day-names-margin-top: var(--otk-theme-space-m);
      --otk-ui-datepicker-day-name-color: var(--otk-theme-color-grey-700);
      --otk-ui-datepicker-day-name-text-transform: capitalize;
      --otk-ui-datepicker-day-color: var(--otk-theme-color-grey-500);
      --otk-ui-datepicker-day-hover-color: var(--otk-theme-color-grey-600);
      --otk-ui-datepicker-day-border-radius: 0;
      --otk-ui-datepicker-day-selected-background-color: var(--otk-theme-color-primary);
      --otk-ui-datepicker-day-selected-border-radius: 0px;
      --otk-ui-datepicker-day-selected-color: var(--otk-theme-color-grey-900);
      --otk-ui-datepicker-day-highlighted-background-color: var(--otk-theme-color-grey-200);
      --otk-ui-datepicker-day-highlighted-color: var(--otk-theme-color-grey-600);
      --otk-ui-datepicker-day-highlighted-hover-color: var(--otk-theme-color-grey-800);

      // -- badge
      --otk-ui-badge-border-radius: 3px;

      // -- modal
      --otk-ui-modal-description-color: var(--otk-theme-color-secondary);
      --otk-ui-modal-close-button-size: 20px;
      --otk-ui-modal-close-button-top: 20px;
      --otk-ui-modal-close-button-right: 20px;
      --otk-ui-modal-close-button-color: var(--otk-theme-color-secondary);
    }
  `,
  [tenantsNames.alianza]: `
    :root {
      //login
      --login-button-bg-hover: #2563EB;
      --login-button-bg: #2563EB;
      --login-logo-width: 200px;

      // authorization
      --ntk-authorization-button-background-hover: var(--login-button-bg-hover);
      --ntk-authorization-button-background: var(--login-button-bg);
      --ntk-authorization-logo-width: var(--login-logo-width);

      // primary top-bar
      --primary-top-bar: #FFF;
      --primary-top-bar-color: #2396DC;
      --primary-top-bar-border: 1px solid #E2E8EE;
      --primary-top-bar-logo-margin-top: 0;
      --primary-top-bar-logo-padding: 6px 0;
      --button-primary-bg: #2396DC;

      // -- input
      --otk-ui-input-height: 40px;
      --otk-ui-input-padding: var(--otk-theme-space-xs) var(--otk-theme-space-s) var(--otk-theme-space-2xs);
      --otk-theme-color-blue-100: #BFDBFE;
      --otk-theme-color-blue-200: #e0eaff;
      --otk-theme-color-blue-500: #2563EB;
      --otk-ui-table-pagination-element-is-selected-background: var(--otk-theme-color-blue-500);
      --otk-theme-font-size-s: 13.5px;
      --otk-theme-font-size-m: 14px;
      --otk-theme-font-size-l: 15px;
      --otk-theme-font-size-xs: 12px;
    }

    body {
      background-color: #fff !important;
    }`
};

// src/base-theme.ts
var baseThemeGlobalVariables = `
  :root {
    // login
    --login-bg-color: #fff;
    --login-button-color: #fff;
    --login-button-bg-hover: hsl(200, 71%, 53%);
    --login-button-bg: #57B1E5;

    // general
    --error-100: #ffe0e2;
    --error-900: #cc000a;
    --primary-background: #fff;
    --grey100: #f2f5f8;
    --grey200: #e2e8ee;
    --grey300: #ccd6e0;
    --grey500: #94A6B8;
    --grey700: #54708C;
    --grey900: #263340;
    --primary-500: #2396DC;
    --primary500: #2396DC;
    --accent-color-blue: var(--primary-500);
    --accent-color-gray: #E2E8EE;
    --input-background: #e0eaff;
    --font-family-primary: Roboto;
    --font-size-3xl: 24px;
    --font-size-2xl: 20px;
    --font-size-xl: 18px;
    --font-size-l: 18px;
    --font-size-m: 16px;
    --font-size: 14px;
    --font-size-s: 12px;
    --font-size-xs: 10px;
    --font-weight-m: 500;
    --font-weight: 400;
    --button-primary-bg: #01309a;

    // primary top-bar
    --primary-top-bar-logo-margin: 0 1.6rem;
    --primary-top-bar-submenu-icon: #94A6B8;
    --primary-top-bar-submenu-icon-hover: var(--button-primary-bg);

    // tenant theme
    --otk-theme-font-family-primary: var(--font-family-primary);
    --otk-theme-font-size-4xl: 28px;
    --otk-theme-font-size-3xl: var(--font-size-3xl);
    --otk-theme-font-size-2xl: var(--font-size-2xl);
    --otk-theme-font-size-xl: var(--font-size-xl);
    --otk-theme-font-size-l: var(--font-size-l);
    --otk-theme-font-size-m: var(--font-size-m);
    --otk-theme-font-size: var(--font-size);
    --otk-theme-font-size-s: 12px;
    --otk-theme-font-size-2xs: 8px;
    --otk-theme-font-line-height-4xl: var(--otk-theme-font-size-4xl);
    --otk-theme-font-line-height-3xl: var(--otk-theme-font-size-3xl);
    --otk-theme-font-line-height-2xl: var(--otk-theme-font-size-2xl);
    --otk-theme-font-line-height-xl: var(--otk-theme-font-size-xl);
    --otk-theme-font-line-height-l: var(--otk-theme-font-size-l);
    --otk-theme-font-line-height-m: var(--otk-theme-font-size-m);
    --otk-theme-font-line-height: var(--otk-theme-font-size);
    --otk-theme-font-line-height-s: var(--otk-theme-font-size-s);
    --otk-theme-font-line-height-2xs: var(--otk-theme-font-size-2xs);
    --otk-theme-font-weight-extra-bold: 900;
    --otk-theme-font-weight-bold: 700;
    --otk-theme-font-weight-medium: var(--font-weight-m);
    --otk-theme-font-weight-regular: var(--font-weight);
    --otk-theme-font-weight-light: 200;
    --otk-theme-font-weight: var(--otk-theme-font-weight-regular);
    --otk-theme-color-white: #FFF;
    --otk-theme-color-black: #000;
    --otk-theme-color-blue-900: #0b2d42;
    --otk-theme-color-blue-800: #124b6e;
    --otk-theme-color-blue-700: #19699a;
    --otk-theme-color-blue-600: #2087c6;
    --otk-theme-color-blue-500: #39a0df;
    --otk-theme-color-blue-400: #65b5e6;
    --otk-theme-color-blue-300: #91caed;
    --otk-theme-color-blue-200: #bddff4;
    --otk-theme-color-blue-100: #e9f4fb;
    --otk-theme-color-red-900: #7f1d1d;
    --otk-theme-color-red-800: #991b1b;
    --otk-theme-color-red-700: #b91c1c;
    --otk-theme-color-red-600: #dc2626;
    --otk-theme-color-red-500: #ef4444;
    --otk-theme-color-red-400: #f87171;
    --otk-theme-color-red-300: #fca5a5;
    --otk-theme-color-red-200: #fecaca;
    --otk-theme-color-red-100: #fee2e2;
    --otk-theme-color-green-900: #14532d;
    --otk-theme-color-green-800: #166534;
    --otk-theme-color-green-700: #15803d;
    --otk-theme-color-green-600: #16a34a;
    --otk-theme-color-green-500: #22c55e;
    --otk-theme-color-green-400: #4ade80;
    --otk-theme-color-green-300: #86efac;
    --otk-theme-color-green-200: #bbf7d0;
    --otk-theme-color-green-100: #dcfce7;
    --otk-theme-color-orange-900: #7c2d12;
    --otk-theme-color-orange-800: #9a3412;
    --otk-theme-color-orange-700: #c2410c;
    --otk-theme-color-orange-600: #ea580c;
    --otk-theme-color-orange-500: #f97316;
    --otk-theme-color-orange-400: #fb923c;
    --otk-theme-color-orange-300: #fdba74;
    --otk-theme-color-orange-200: #fed7aa;
    --otk-theme-color-orange-100: #ffedd5;
    --otk-theme-color-yellow-900: #1a1400;
    --otk-theme-color-yellow-800: #4d3d00;
    --otk-theme-color-yellow-700: #806600;
    --otk-theme-color-yellow-600: #b38f00;
    --otk-theme-color-yellow-500: #e6b800;
    --otk-theme-color-yellow-400: #ffcc00;
    --otk-theme-color-yellow-300: #ffdb4d;
    --otk-theme-color-yellow-200: #ffe680;
    --otk-theme-color-yellow-100: #fff0b3;
    --otk-theme-color-midnight-express-100: #ecf0f5;
    --otk-theme-color-midnight-express-200: #c7d2e2;
    --otk-theme-color-midnight-express-300: #a2b4ce;
    --otk-theme-color-midnight-express-400: #7d96bb;
    --otk-theme-color-midnight-express-500: #5878a7;
    --otk-theme-color-midnight-express-600: #445d82;
    --otk-theme-color-midnight-express-700: #31435d;
    --otk-theme-color-midnight-express-800: #1d2838;
    --otk-theme-color-midnight-express-900: #0a0d13;
    --otk-theme-color-midnight-express: var(--otk-theme-color-midnight-express-500);
    --otk-theme-color-grey-100: #f2f5f8;
    --otk-theme-color-grey-200: #e2e8ee;
    --otk-theme-color-grey-300: #ccd6e0;
    --otk-theme-color-grey-400: #b3bfcc;
    --otk-theme-color-grey-500: #94A6B8;
    --otk-theme-color-grey-600: #758ca3;
    --otk-theme-color-grey-700: #54708C;
    --otk-theme-color-grey-800: #47596b;
    --otk-theme-color-grey-900: #263340;
    --otk-theme-color-grey: var(--otk-theme-color-grey-500);
    --otk-theme-color-grey-hover: var(--otk-theme-color-grey-700);
    --otk-theme-color-grey-disabled: var(--otk-theme-color-grey-200);
    --otk-theme-color-primary-900: var(--otk-theme-color-blue-900);
    --otk-theme-color-primary-800: var(--otk-theme-color-blue-800);
    --otk-theme-color-primary-700: var(--otk-theme-color-blue-700);
    --otk-theme-color-primary-600: var(--otk-theme-color-blue-600);
    --otk-theme-color-primary-500: var(--otk-theme-color-blue-500);
    --otk-theme-color-primary-400: var(--otk-theme-color-blue-400);
    --otk-theme-color-primary-300: var(--otk-theme-color-blue-300);
    --otk-theme-color-primary-200: var(--otk-theme-color-blue-200);
    --otk-theme-color-primary-100: var(--otk-theme-color-blue-100);
    --otk-theme-color-ghost: var(--otk-theme-color-grey-100);
    --otk-theme-color-primary: var(--otk-theme-color-primary-500);
    --otk-theme-color-primary-ghost: var(--otk-theme-color-primary-100);
    --otk-theme-color-primary-soft: var(--otk-theme-color-primary-300);
    --otk-theme-color-primary-soft-hover: var(--otk-theme-color-primary-400);
    --otk-theme-color-primary-soft-disabled: var(--otk-theme-color-primary-200);
    --otk-theme-color-primary-hover: var(--otk-theme-color-primary-600);
    --otk-theme-color-primary-disabled: var(--otk-theme-color-primary-200);
    --otk-theme-color-secondary-900: var(--otk-theme-color-yellow-900);
    --otk-theme-color-secondary-800: var(--otk-theme-color-yellow-800);
    --otk-theme-color-secondary-700: var(--otk-theme-color-yellow-700);
    --otk-theme-color-secondary-600: var(--otk-theme-color-yellow-600);
    --otk-theme-color-secondary-500: var(--otk-theme-color-yellow-500);
    --otk-theme-color-secondary-500: var(--otk-theme-color-yellow-500);
    --otk-theme-color-secondary-400: var(--otk-theme-color-yellow-400);
    --otk-theme-color-secondary-300: var(--otk-theme-color-yellow-300);
    --otk-theme-color-secondary-200: var(--otk-theme-color-yellow-200);
    --otk-theme-color-secondary-100: var(--otk-theme-color-yellow-100);
    --otk-theme-color-secondary: var(--otk-theme-color-secondary-500);
    --otk-theme-color-background-color-white: var(--otk-theme-color-white);
    --otk-theme-color-background-color-primary: var(--primary-background);
    --otk-theme-color-accent-primary: var(--otk-theme-color-primary-500);
    --otk-theme-color-accent-primary-disabled: var(--otk-theme-color-primary-300);
    --otk-theme-color-accent-gray: var(--accent-color-gray);
    --otk-theme-color-error-100: var(--error-100);
    --otk-theme-color-error-900: var(--error-900);
    --otk-theme-color-error: var(--otk-theme-color-red-600);
    --otk-theme-color-warning-800: #fcb605;
    --otk-theme-color-warning: var(--otk-theme-color-yellow-500);
    --otk-theme-color-info-800: var(--otk-theme-color-primary-400);
    --otk-theme-color-info: var(--otk-theme-color-blue-500);
    --otk-theme-color-success-800: #00b573;
    --otk-theme-color-success: var(--otk-theme-color-success-800);
    --otk-theme-space-2xl: 40px;
    --otk-theme-space-3xl: 48px;
    --otk-theme-space-4xl: 56px;
    --otk-theme-space-5xl: 64px;
    --otk-theme-space-l: 24px;
    --otk-theme-space-m: 16px;
    --otk-theme-space-s: 8px;
    --otk-theme-space-xl: 32px;
    --otk-theme-space-xs: 4px;
    --otk-theme-space-2xs: 2px;
    --otk-theme-space: 12px;
    --otk-theme-border-radius: 8px;
    --otk-theme-border-radius-s: 4px;
    --otk-theme-border-color: var(--otk-theme-color-grey-300);
    --otk-theme-border: 1px solid var(--otk-theme-border-color);
    --otk-theme-border-error: 1px solid var(--otk-theme-color-error-900);
    --otk-theme-border-disabled: 1px solid var(--otk-theme-color-grey-300);
    --otk-theme-font-color: var(--otk-theme-color-grey-700);

    // authorization
    --ntk-authorization-background-color: var(--login-bg-color);
    --ntk-authorization-button-color: var(--login-button-color);
    --ntk-authorization-button-background-hover: var(--login-button-bg-hover);
    --ntk-authorization-button-background: var(--login-button-bg);
    --ntk-authorization-button-size-s-min-height: var(--otk-theme-space-4xl);
    --ntk-authorization-button-size-s-padding: var(--otk-theme-space-s) var(--otk-theme-space-m);
    --ntk-authorization-button-size-s-font-size: var(--otk-theme-font-size-s);
    --ntk-authorization-button-size-m-min-height: var(--otk-theme-space-s);
    --ntk-authorization-button-size-m-padding: var(--otk-theme-space-s) var(--otk-theme-space-m);
    --ntk-authorization-button-size-m-font-size: var(--otk-theme-font-size);
    --ntk-authorization-button-size-l-min-height: var(--otk-theme-space-m);
    --ntk-authorization-button-size-l-padding: var(--otk-theme-space-m) var(--otk-theme-space-l);
    --ntk-authorization-button-size-l-font-size: var(--otk-theme-font-size-m);
    --ntk-authorization-button-border-radius: var(--otk-theme-border-radius-s);
    --ntk-authorization-link-margin-top: var(--otk-theme-space-l);
    --ntk-authorization-link-font-size: var(--otk-theme-font-size);
    --ntk-authorization-link-font-weight: var(--otk-theme-font-weight-regular);
    --ntk-authorization-link-primary-color: var(--login-button-bg);
    --ntk-authorization-link-primary-color-hover: var(--login-button-bg-hover);
    --ntk-authorization-link-secondary-color: var(--login-button-bg);
    --ntk-authorization-link-secondary-color-hover: var(--login-button-bg-hover);
    --ntk-authorization-link-focus-outline: 2px solid var(--login-button-bg);
    --ntk-authorization-link-focus-outline-offset: 2px;
    --ntk-authorization-link-disabled-color: var(--login-button-bg-hover);
    --ntk-authorization-link-disabled-opacity: 0.6;
    --ntk-authorization-logo-width: var(--login-logo-width);
    --ntk-authorization-error-color: var(--otk-theme-color-error-900);
    --ntk-authorization-form-gap: var(--otk-theme-space-s);
    --ntk-authorization-form-padding: var(--otk-theme-space-m);
    --ntk-authorization-form-width: 400px;
    --ntk-authorization-modal-background: var(--otk-theme-color-white);
    --ntk-authorization-modal-border: 0;
    --ntk-authorization-modal-border-radius: var(--otk-theme-border-radius-m);
    --ntk-authorization-modal-color: var(--otk-theme-color-grey-900);
    --ntk-authorization-modal-padding: var(--otk-theme-space-l);
    --ntk-authorization-modal-backdrop: rgb(0 0 0 / 45%);
    --ntk-authorization-modal-size-s-width: 420px;
    --ntk-authorization-modal-size-s-min-height: 180px;
    --ntk-authorization-modal-size-m-width: 560px;
    --ntk-authorization-modal-size-m-min-height: 260px;
    --ntk-authorization-modal-size-l-width: 720px;
    --ntk-authorization-modal-size-l-min-height: 320px;
    --ntk-authorization-modal-title-color: var(--otk-theme-color-grey-900);
    --ntk-authorization-modal-title-font-family: var(--otk-theme-font-family-primary);
    --ntk-authorization-modal-title-font-size: var(--otk-theme-font-size-l);
    --ntk-authorization-modal-title-margin: 0 0 var(--otk-theme-space-m);
    --ntk-authorization-modal-close-button-color: var(--otk-theme-color-grey-700);
    --ntk-authorization-modal-close-button-font-size: var(--otk-theme-font-size-l);
    --ntk-authorization-modal-close-button-right: var(--otk-theme-space-m);
    --ntk-authorization-modal-close-button-top: var(--otk-theme-space-m);
    --ntk-authorization-title-font-size: var(--otk-theme-font-size-2xl );
    --ntk-authorization-title-color: var(--otk-theme-color-grey-900);
    --ntk-authorization-title-font-family: Roboto;
    --ntk-authorization-title-margin: var(--otk-theme-space-s) 0 var(--otk-theme-space-s) 0;
    --ntk-authorization-input-background: var(--otk-ui-input-background);
    --ntk-authorization-input-border: var(--otk-ui-input-border);
    --ntk-authorization-input-border-radius: var(--otk-ui-input-border-radius);
    --ntk-authorization-input-color: var(--otk-theme-color-grey-900);
    --ntk-authorization-input-font-family: var(--otk-theme-font-family-primary);
    --ntk-authorization-input-font-size: var(--otk-theme-font-size-m);
    --ntk-authorization-input-line-height: var(--otk-theme-font-line-height-m);
    --ntk-authorization-input-min-height: var(--otk-ui-input-height);
    --ntk-authorization-input-padding: var(--otk-ui-input-padding);
    --ntk-authorization-input-focus-border: var(--otk-ui-input-has-focus-border);
    --ntk-authorization-input-error-border: var(--otk-ui-input-is-error-border);
    --ntk-authorization-success-message-font-family: var(--otk-theme-font-family-primary);
    --ntk-authorization-success-message-font-size: var(--otk-theme-font-size-m);
    --ntk-authorization-success-message-color: var(--otk-theme-color-grey-700);
    --ntk-authorization-success-message-margin: var(--otk-theme-space-s);

    // ui components

    // -- text
    --otk-ui-text-color: var(--otk-theme-font-color);
    --otk-ui-text-color-light: var(-otk-theme-color-white);
    --otk-ui-text-color-primary: var(--otk-theme-color-primary);
    --otk-ui-text-color-secondary: var(--otk-theme-color-secondary);

    // -- icons
    --otk-ui-icon-s-size: 12px;
    --otk-ui-icon-xs-size: 8px;
    --otk-ui-icon-2xs-size: 6px;
    --otk-ui-icon-m-size: 16px;
    --otk-ui-icon-l-size: 20px;
    --otk-ui-icon-xl-size: 24px;
    --otk-ui-icon-primary-color: var(--otk-theme-color-primary);
    --otk-ui-icon-secondary-color: var(--otk-theme-color-secondary);
    --otk-ui-icon-gey-color: var(--otk-theme-color-grey);

    // -- input
    --otk-ui-input-border: var(--otk-theme-border);
    --otk-ui-input-is-error-border: var(--otk-theme-border-error);
    --otk-ui-input-is-disabled-border: var(--otk-theme-border-disabled);
    --otk-ui-input-has-focus-border: 1px solid var(--primary-500);
    --otk-ui-input-border-radius: var(--otk-theme-border-radius-s);
    --otk-ui-input-background: var(--otk-theme-color-background-color-primary);
    --otk-ui-input-is-readonly-background: var(--otk-theme-color-grey-100);
    --otk-ui-input-is-disabled-background: var(--otk-theme-color-accent-gray);
    --otk-ui-input-has-error-background: var(--otk-theme-color-error-100);
    --otk-ui-input-height: 40px;
    --otk-ui-input-padding: var(--otk-theme-space-xs) var(--otk-theme-space-s) var(--otk-theme-space-xs) var(--otk-theme-space-s);

    // -- textarea
    --otk-ui-textarea-height: 120px;

    // -- datepicker
    --otk-ui-datepicker-header-background-color: #f0f0f0;
    --otk-ui-datepicker-navigation-next-border-left-color: #ccc;
    --otk-ui-datepicker-navigation-next-hover-border-left-color: rgb(178.5, 178.5, 178.5);
    --otk-ui-datepicker-header-border-bottom: 1px solid #aeaeae;
    --otk-ui-datepicker-header-border-top-left-radius: 0.3rem;
    --otk-ui-datepicker-header-border-top-right-radius: 0.3rem;
    --otk-ui-datepicker-header-padding-top: 8px;
    --otk-ui-datepicker-header-position: relative;
    --otk-ui-datepicker-current-month-color: #000;
    --otk-ui-datepicker-day-names-margin-top: 0;
    --otk-ui-datepicker-day-name-color: #000;
    --otk-ui-datepicker-day-name-text-transform: none;
    --otk-ui-datepicker-day-color: #000;
    --otk-ui-datepicker-day-hover-color: #000;
    --otk-ui-datepicker-day-border-radius: 0.3em;
    --otk-ui-datepicker-day-selected-background-color: #216ba5;
    --otk-ui-datepicker-day-selected-border-radius: 0.3em;
    --otk-ui-datepicker-day-selected-color: #000;
    --otk-ui-datepicker-day-highlighted-background-color: #e2e8ee);
    --otk-ui-datepicker-day-highlighted-color: #000;
    --otk-ui-datepicker-day-highlighted-hover-color: #000;

    // -- checkbox
    --otk-ui-checkbox-size: 20px;
    --otk-ui-checkbox-border: 2px solid var(--otk-theme-border-color);
    --otk-ui-checkbox-border-radius: var(--otk-theme-border-radius-s);
    --otk-ui-checkbox-is-checked-background-color: var(--otk-theme-color-grey-600);
    --otk-ui-checkbox-is-checked-border-color: var(--otk-theme-color-grey-600);
    --otk-ui-checkbox-is-checked-after-width: 5px;
    --otk-ui-checkbox-is-checked-after-height: 10px;
    --otk-ui-checkbox-is-checked-after-top: 1px;
    --otk-ui-checkbox-is-checked-after-left: 5px;
    --otk-ui-checkbox-is-checked-after-border-color: var(--otk-theme-color-white);
    --otk-ui-checkbox-is-hover-border-color: var(--otk-theme-color-grey-600);
    --otk-ui-checkbox-disabled-background-color: var(--otk-theme-color-grey-100);
    --otk-ui-checkbox-disabled-border-color: var(--otk-theme-color-grey-300);


    --otk-ui-checkbox-primary-is-checked-background-color: var(--otk-theme-color-primary);
    --otk-ui-checkbox-primary-is-checked-border-color: var(--otk-theme-color-primary);
    --otk-ui-checkbox-primary-is-checked-after-border-color: var(--otk-theme-color-secondary);

    // -- radio
    --otk-ui-radio-gap: 8px;
    --otk-ui-radio-size: 20px;
    --otk-ui-radio-border: 2px solid var(--otk-theme-border-color);
    --otk-ui-radio-border-radius: var(--otk-theme-border-radius-s);
    --otk-ui-radio-is-checked-dot-size: 8px;
    --otk-ui-radio-is-checked-background-color: var(--otk-theme-color-primary);
    --otk-ui-radio-is-checked-dot-color: var(--otk-theme-color-white);
    --otk-ui-radio-checked-border-color: var(--otk-theme-color-primary);

    // -- radios
    --otk-ui-radios-gap: var(--otk-theme-space-s);

    // -- buttons
    --otk-ui-button-font-family: var(--otk-theme-font-family-primary);
    --otk-ui-button-m-font-size: var(--otk-theme-font-size-m);
    --otk-ui-button-font-size: var(--otk-theme-font-size);
    --otk-ui-button-xs-font-size: var(--otk-theme-font-size-s);
    --otk-ui-button-l-font-weight: var(--otk-theme-font-weight-medium);
    --otk-ui-button-font-weight: var(--otk-theme-font-weight-regular);
    --otk-ui-button-line-height: var(--otk-theme-font-size-m);
    --otk-ui-button-border-radius: var(--otk-theme-border-radius-s);
    --otk-ui-button-m-padding: var(--otk-theme-space-m) var(--otk-theme-space-l);
    --otk-ui-button-s-padding: var(--otk-theme-space-s) var(--otk-theme-space-m);
    --otk-ui-button-xs-padding: var(--otk-theme-space-s) var(--otk-theme-space-m);
    --otk-ui-button-2xs-padding: var(--otk-theme-space-2xs) var(--otk-theme-space-xs);

    --otk-ui-button-border: 1px solid var(--otk-theme-color-grey);
    --otk-ui-button-hover-border: 1px solid var(--otk-theme-color-grey-hover);
    --otk-ui-button-background: var(--otk-theme-color-grey);
    --otk-ui-button-hover-background: var(--otk-theme-color-grey-hover);
    --otk-ui-button-color: var(--otk-theme-color-background-color-primary);
    --otk-ui-button-hover-color: var(--otk-theme-color-background-color-primary);
    --otk-ui-button-disabled-border: 1px solid var(--otk-theme-color-grey-disabled);
    --otk-ui-button-disabled-background: var(--otk-theme-color-grey-disabled);
    --otk-ui-button-disabled-color: var(--otk-theme-color-background-color-primary);

    --otk-ui-button-outline-border: 1px solid var(--otk-theme-color-grey);
    --otk-ui-button-outline-hover-border: 1px solid var(--otk-theme-color-grey-hover);
    --otk-ui-button-outline-background: transparent;
    --otk-ui-button-outline-hover-background: transparent;
    --otk-ui-button-outline-color: var(--otk-theme-color-grey);
    --otk-ui-button-outline-hover-color: var(--otk-theme-color-grey-hover);
    --otk-ui-button-outline-disabled-border: 1px solid var(--otk-theme-color-grey-disabled);
    --otk-ui-button-outline-disabled-background: transparent;
    --otk-ui-button-outline-disabled-color: var(--otk-theme-color-grey-disabled);

    --otk-ui-button-ghost-border: 1px solid transparent;
    --otk-ui-button-ghost-hover-border: 1px solid var(--otk-theme-color-ghost);
    --otk-ui-button-ghost-background: transparent;
    --otk-ui-button-ghost-hover-background: var(--otk-theme-color-ghost);
    --otk-ui-button-ghost-color: var(--otk-theme-color-grey);
    --otk-ui-button-ghost-hover-color: var(--otk-theme-color-grey-hover);
    --otk-ui-button-ghost-disabled-border: 1px solid var(--otk-theme-color-grey-disabled);
    --otk-ui-button-ghost-disabled-background: transparent;
    --otk-ui-button-ghost-disabled-color: var(--otk-theme-color-grey-disabled);

    --otk-ui-button-primary-border: 1px solid var(--otk-theme-color-primary);
    --otk-ui-button-primary-hover-border: 1px solid var(--otk-theme-color-primary-hover);
    --otk-ui-button-primary-background: var(--otk-theme-color-primary);
    --otk-ui-button-primary-hover-background: var(--otk-theme-color-primary-hover);
    --otk-ui-button-primary-color: var(--otk-theme-color-background-color-primary);
    --otk-ui-button-primary-hover-color: var(--otk-theme-color-background-color-primary);
    --otk-ui-button-primary-disabled-border: 1px solid var(--otk-theme-color-primary-disabled);
    --otk-ui-button-primary-disabled-background: var(--otk-theme-color-primary-disabled);
    --otk-ui-button-primary-disabled-color: var(--otk-theme-color-background-color-primary);

    --otk-ui-button-icon-background: transparent;
    --otk-ui-button-icon-s-size: 25px;
    --otk-ui-button-icon-2xs-size: 15px;
    --otk-ui-button-icon-size: 50px;
    --otk-ui-button-icon-hover-background: transparent;
    --otk-ui-button-icon-border: 1px solid transparent;
    --otk-ui-button-icon-hover-border: 1px solid transparent;
    --otk-ui-button-icon-primary-background: var(--otk-theme-color-primary);
    --otk-ui-button-icon-primary-hover-background: var(--otk-theme-color-primary-hover);
    --otk-ui-button-icon-primary-color: var(--otk-theme-color-secondary);
    --otk-ui-button-icon-primary-hover-color: var(--otk-theme-color-secondary);
    --otk-ui-button-icon-primary-disabled-border: 1px solid var(--otk-theme-color-primary-disabled);
    --otk-ui-button-icon-primary-disabled-background: var(--otk-theme-color-primary-disabled);
    --otk-ui-button-icon-primary-disabled-color: var(--otk-theme-color-secondary-disabled);
    --otk-ui-button-icon-secondary-background: var(--otk-theme-color-secondary);
    --otk-ui-button-icon-secondary-hover-background: var(--otk-theme-color-secondary-hover);
    --otk-ui-button-icon-secondary-color: var(--otk-theme-color-primary);
    --otk-ui-button-icon-secondary-hover-color: var(--otk-theme-color-primary);
    --otk-ui-button-icon-secondary-disabled-border: 1px solid var(--otk-theme-color-secondary-disabled);
    --otk-ui-button-icon-secondary-disabled-background: var(--otk-theme-color-secondary-disabled);
    --otk-ui-button-icon-secondary-disabled-color: var(--otk-theme-color-primary-disabled);

    --otk-ui-button-primary-outline-border: 1px solid var(--otk-theme-color-primary);
    --otk-ui-button-primary-outline-hover-border: 1px solid var(--otk-theme-color-primary-hover);
    --otk-ui-button-primary-outline-background: transparent;
    --otk-ui-button-primary-outline-hover-background: transparent;
    --otk-ui-button-primary-outline-color: var(--otk-theme-color-primary);
    --otk-ui-button-primary-outline-hover-color: var(--otk-theme-color-primary-hover);
    --otk-ui-button-primary-outline-disabled-border: 1px solid var(--otk-theme-color-primary-disabled);
    --otk-ui-button-primary-outline-disabled-background: transparent;
    --otk-ui-button-primary-outline-disabled-color: var(--otk-theme-color-primary-disabled);

    --otk-ui-button-primary-ghost-border: 1px solid transparent;
    --otk-ui-button-primary-ghost-hover-border: 1px solid var(--otk-theme-color-primary-ghost);
    --otk-ui-button-primary-ghost-background: transparent;
    --otk-ui-button-primary-ghost-hover-background: var(--otk-theme-color-primary-ghost);
    --otk-ui-button-primary-ghost-color: var(--otk-theme-color-primary);
    --otk-ui-button-primary-ghost-hover-color: var(--otk-theme-color-primary-700);
    --otk-ui-button-primary-ghost-disabled-border: 1px solid transparent;
    --otk-ui-button-primary-ghost-disabled-background: transparent;
    --otk-ui-button-primary-ghost-disabled-color: var(--otk-theme-color-primary-disabled);

    --otk-ui-button-text-margin: var(--otk-theme-space-s) var(--otk-theme-space-m);
    --otk-ui-button-text-border: 1px solid transparent;
    --otk-ui-button-primary-text-border: 1px solid transparent;
    --otk-ui-button-primary-text-hover-border: 1px solid transparent;
    --otk-ui-button-primary-text-background: transparent;
    --otk-ui-button-primary-text-hover-background: transparent;
    --otk-ui-button-primary-text-color: var(--otk-theme-color-primary);
    --otk-ui-button-primary-text-hover-color: var(--otk-theme-color-primary-hover);
    --otk-ui-button-primary-text-disabled-border: 1px solid transparent;
    --otk-ui-button-primary-text-disabled-background: transparent;
    --otk-ui-button-primary-text-disabled-color: var(--otk-theme-color-primary-disabled);

    --otk-ui-button-primary-soft-border: 1px solid var(--otk-theme-color-primary-soft);
    --otk-ui-button-primary-soft-hover-border: 1px solid var(--otk-theme-color-primary-soft-hover);
    --otk-ui-button-primary-soft-background: var(--otk-theme-color-primary-soft);
    --otk-ui-button-primary-soft-hover-background: var(--otk-theme-color-primary-soft-hover);
    --otk-ui-button-primary-soft-color: var(--otk-theme-color-primary-700);
    --otk-ui-button-primary-soft-hover-color: var(--otk-theme-color-primary-900);
    --otk-ui-button-primary-soft-disabled-border: 1px solid var(--otk-theme-color-primary-soft-disabled);
    --otk-ui-button-primary-soft-disabled-background: var(--otk-theme-color-primary-soft-disabled);
    --otk-ui-button-primary-soft-disabled-color: var(--otk-theme-color-primary-300);

    --otk-ui-button-secondary-border: 1px solid var(--otk-theme-color-secondary);
    --otk-ui-button-secondary-hover-border: 1px solid var(--otk-theme-color-secondary-hover);
    --otk-ui-button-secondary-background: var(--otk-theme-color-secondary);
    --otk-ui-button-secondary-hover-background: var(--otk-theme-color-secondary-hover);
    --otk-ui-button-secondary-color: var(--otk-theme-color-background-color-secondary);
    --otk-ui-button-secondary-hover-color: var(--otk-theme-color-background-color-secondary);
    --otk-ui-button-secondary-disabled-border: 1px solid var(--otk-theme-color-secondary-disabled);
    --otk-ui-button-secondary-disabled-background: var(--otk-theme-color-secondary-disabled);
    --otk-ui-button-secondary-disabled-color: var(--otk-theme-color-background-color-secondary);

    --otk-ui-button-group-border: 1px solid var(--otk-theme-color-grey-700),
    --otk-ui-button-group-background: var(--otk-theme-color-grey-200);
    --otk-ui-button-group-color: var(--otk-theme-color-grey-800);

    // -- avatar
    --otk-ui-avatar-container-gap: var(--otk-theme-space);
    --otk-ui-avatar-wrapper-size: var(--otk-theme-space-xl);
    --otk-ui-avatar-letters-size: var(--otk-ui-avatar-wrapper-size);
    --otk-ui-avatar-letters-font-size: var(--otk-theme-font-size);
    --otk-ui-avatar-letters-font-weight: var(--otk-theme-font-weight-l);
    --otk-ui-avatar-letters-color: var(--otk-theme-color-white);
    --otk-ui-avatar-background: var(--otk-theme-color-grey-500);

    // -- spinner
    --otk-ui-spinner-color: var(--otk-theme-color-grey);
    --otk-ui-spinner-primary-color: var(--otk-theme-color-primary);
    --otk-ui-spinner-secondary-color: var(--otk-theme-color-secondary);

    // -- badge
    --otk-ui-badge-background-color: var(--grey300);
    --otk-ui-badge-color: var(--grey700);
    --otk-ui-badge-font-family: Roboto;
    --otk-ui-badge-font-size: 12px;
    --otk-ui-badge-font-weight: 700;
    --otk-ui-badge-padding: 2px 6px;
    --otk-ui-badge-border-radius: 5px;
    --otk-ui-badge-border-left-color-error: var(--otk-theme-color-error);
    --otk-ui-badge-border-left-color-warning: var(--otk-theme-color-warning);
    --otk-ui-badge-border-left-color-success: var(--otk-theme-color-success);
    --otk-ui-badge-border-left-color-info: var(--otk-theme-color-info);
    --otk-ui-badge-border-left-color-default: var(--otk-theme-color-grey);
    --otk-ui-badge-primary-background-color: var(--otk-theme-color-primary);
    --otk-ui-badge-primary-color: var(--otk-theme-color-secondary);
    --otk-ui-badge-secondary-background-color: var(--otk-theme-color-secondary);
    --otk-ui-badge-secondary-color: var(--otk-theme-color-primary);

    // -- ball
    --otk-ui-ball-size: 10px;
    --otk-ui-ball-background-color: var(--otk-theme-color-error-900);

    // -- accordion
    --otk-ui-accordion-border: 1px solid var(--otk-theme-color-grey-300);
    --otk-ui-accordion-background-color: var(--otk-theme-color-background-color-primary);
    --otk-ui-accordion-trigger-padding: var(--otk-theme-space-s) var(--otk-theme-space-m);
    --otk-ui-accordion-trigger-border-bottom: var(--otk-ui-accordion-border);
    --otk-ui-accordion-content-padding: var(--otk-theme-space-s) var(--otk-theme-space-m);
    --otk-ui-accordion-icon-fill: var(--otk-theme-color-grey-700);
    --otk-ui-accordion-icon-hover-fill: var(--otk-theme-color-grey-900);

    // -- modal
    --otk-ui-modal-container-padding: var(--otk-theme-space-l);
    --otk-ui-modal-container-border-radius: var(--otk-theme-border-radius);
    --otk-ui-modal-container-background: var(--otk-theme-color-grey-100);
    --otk-ui-modal-section-gap: var(--otk-theme-space-m);
    --otk-ui-modal-header-gap: var(--otk-theme-space-xs);
    --otk-ui-modal-title-font-family: var(--otk-theme-font-family-primary);
    --otk-ui-modal-title-font-size: var(--otk-theme-font-size);
    --otk-ui-modal-title-font-weight: var(--otk-theme-font-weight-medium);
    --otk-ui-modal-title-color: var(--otk-theme-color-grey-700);
    --otk-ui-modal-description-font-family: var(--otk-theme-font-family-primary);
    --otk-ui-modal-description-font-size: var(--otk-theme-font-size-l);
    --otk-ui-modal-description-font-weight: var(--otk-theme-font-weight-medium);
    --otk-ui-modal-description-color: var(--otk-theme-color-primary-500);
    --otk-ui-modal-footer-gap: var(--otk-theme-space-s);
    --otk-ui-modal-close-button-size: 20px;
    --otk-ui-modal-close-button-top: 20px;
    --otk-ui-modal-close-button-right: 20px;
    --otk-ui-modal-close-button-color: var(--otk-theme-color-primary);

    // -- table

    // ---- header
    --otk-ui-table-header-background: var(--otk-theme-color-grey-100);
    --otk-ui-table-header-padding: var(--otk-theme-space-xs) 0 var(--otk-theme-space-xs) 0;
    --otk-ui-table-header-cell-border-right: 2px solid var(--otk-theme-color-white, #FFF);
    --otk-ui-table-header-cell-text-color: var(--otk-theme-color-grey-500);
    --otk-ui-table-header-cell-text-font-size: var(--otk-theme-font-size-s);
    --otk-ui-table-header-cell-text-font-weight: var(--otk-theme-font-weight-m);

    // ---- summary
    --otk-ui-table-summary-border-bottom: 1px solid var(--otk-theme-color-grey-200);
    --otk-ui-table-summary-background: var(--otk-theme-color-white);
    --otk-ui-table-summary-height: 40px;

    // ---- row
    --otk-ui-table-row-background-color: var(--otk-theme-color-white);
    --otk-ui-table-row-border-top: 1px solid var(--otk-theme-color-grey-300);
    --otk-ui-table-row-border-bottom: var(--otk-ui-table-row-border-top);
    --otk-ui-table-row-height: 50px;
    --otk-ui-table-row-cell-icon-background-color: var(--otk-theme-color-grey-200);
    --otk-ui-table-row-cell-icon-border-right: none;
    --otk-ui-table-row-accordion-parent-background-color: transparent;
    --otk-ui-table-row-accordion-parent-border-top: 1px solid var(--otk-theme-color-grey-300);
    --otk-ui-table-row-accordion-parent-border-bottom: var(--otk-ui-table-row-accordion-parent-border-top);
    --otk-ui-table-row-accordion-parent-min-height: 45px;
    --otk-ui-table-row-accordion-parent-cell-icon-background-color: var(--otk-theme-color-grey-300);
    --otk-ui-table-row-accordion-parent-cell-icon-border-right: 1px solid var(--otk-theme-color-grey-300);
    --otk-ui-table-row-accordion-content-border-top: 3px solid var(--otk-theme-color-grey-200);
    --otk-ui-table-row-accordion-content-border-bottom: var(--otk-ui-table-row-accordion-content-border-top);
    --otk-ui-table-row-accordion-child-background-color: var(--otk-ui-table-row-background-color);
    --otk-ui-table-row-accordion-child-border-top: var(--otk-ui-table-row-border-top);
    --otk-ui-table-row-accordion-child-border-bottom: var(--otk-ui-table-row-accordion-child-border-top);
    --otk-ui-table-row-accordion-child-height: var(--otk-ui-table-row-height);
    --otk-ui-table-row-accordion-child-cell-icon-background-color: var(--otk-theme-color-grey-100);
    --otk-ui-table-row-accordion-child-cell-icon-border-right: 1px solid var(--otk-theme-color-grey-200);

    // ---- cell
    --otk-ui-table-cell-border-left: 1px solid var(--otk-theme-color-grey-200);
    --otk-ui-table-cell-border-right: 1px solid var(--otk-theme-color-grey-200);

    // ---- empty state
    --otk-ui-table-empty-state-label-color: var(--otk-theme-color-grey-700);
    --otk-ui-table-empty-state-label-font-size: var(--otk-theme-font-size);
    --otk-ui-table-empty-state-label-font-weight : var(--otk-theme-font-weight-m);

    // ---- error
    --otk-ui-table-error-padding: var(--otk-theme-space-5xl) 0 0 0;
    --otk-ui-table-error-label-color: var(--otk-theme-color-error-900);
    --otk-ui-table-error-label-font-size: var(--otk-theme-font-size);
    --otk-ui-table-error-label-font-weight : var(--otk-theme-font-weight-m);

    // ---- pagination
    --otk-ui-table-pagination-background-color: var(--otk-theme-color-white);
    --otk-ui-table-pagination-border-top: 1px solid var(--otk-theme-color-grey-200);
    --otk-ui-table-pagination-gap: var(--otk-theme-space-s);
    --otk-ui-table-pagination-height: 50px;
    --otk-ui-table-pagination-padding: var(--otk-theme-space-xs) 0;
    --otk-ui-table-pagination-page-sizer-width: 140px;
    --otk-ui-table-pagination-page-sizer-padding: var(--otk-theme-space-xs) 0;
    --otk-ui-table-pagination-page-sizer-cell-padding: 0 var(--otk-theme-space-m);
    --otk-ui-table-pagination-elements-margin: 0 0 0 auto;
    --otk-ui-table-pagination-elements-padding: 0 var(--otk-theme-space-xs);
    --otk-ui-table-pagination-elements-cell-padding: var(--ok-ui-table-pagination-page-sizer-cell-padding);;
    --otk-ui-table-pagination-arrow-left-icon-fill: var(--otk-theme-color-grey-500);
    --otk-ui-table-pagination-arrow-right-icon-fill: var(--otk-theme-color-grey-500);
    --otk-ui-table-pagination-element-size: var(--otk-theme-space-xl);
    --otk-ui-table-pagination-element-padding: 0px var(--otk-theme-space-2xs);
    --otk-ui-table-pagination-element-gap: var(--otk-theme-space);
    --otk-ui-table-pagination-element-border-radius: var(--otk-theme-border-radius-s);
    --otk-ui-table-pagination-element-font-family: var(--otk-theme-font-family-primary);
    --otk-ui-table-pagination-element-font-size: var(--otk-theme-font-size);
    --otk-ui-table-pagination-element-font-weight: var(--otk-theme-font-weight-medium);
    --otk-ui-table-pagination-element-arrow-left-margin-right: var(--otk-theme-space-m);
    --otk-ui-table-pagination-element-arrow-right-margin-left: var(--otk-theme-space-m);
    --otk-ui-table-pagination-element-color: var(--otk-theme-color-grey-500);
    --otk-ui-table-pagination-element-is-selected-color: var(--otk-theme-color-white);
    --otk-ui-table-pagination-element-is-selected-background: var(--otk-theme-color-blue-400);
    --otk-ui-table-pagination-element-arrow-icon-fill: var(--otk-theme-color-grey-200);
    --otk-ui-table-pagination-element-arrow-icon-hover-fill: var(--otk-theme-color-grey-700);
    --otk-ui-table-pagination-element-disabled-cursor: not-allowed;
    --otk-ui-table-pagination-element-hover-color: var(--otk-theme-color-blue-400);
    --otk-ui-table-pagination-element-hover-cursor: pointer;
    --otk-ui-table-pagination-element-hover-disabled-cursor: not-allowed;
    --otk-ui-table-pagination-empty-state-message-color: var(--otk-theme-color-grey-500);
    --otk-ui-table-pagination-empty-state-message-font-weight: var(--otk-theme-font-weight-medium);

    // -- toolbar
    --otk-ui-toolbar-button-color: var(--otk-theme-color-primary);
    --otk-ui-toolbar-button-icon-color: var(--otk-theme-color-primary);
    --otk-ui-toolbar-button-is-disabled-color: var(--otk-theme-color-grey-disabled);
    --otk-ui-toolbar-button-icon-is-disabled-color: var(--otk-theme-color-grey-disabled);

    // -- tabs
    --otk-ui-tabs-tab-gap: var(--otk-theme-space);
    --otk-ui-tabs-tab-padding: var(--otk-theme-space-l);
    --otk-ui-tabs-tab-background-color: var(--otk-theme-color-grey-200);
    --otk-ui-tabs-tab-border-left: 1px solid var(--otk-theme-color-white);
    --otk-ui-tabs-tab-is-active-border-bottom: 7px solid var(--otk-theme-color-primary);
    --otk-ui-tabs-tab-border-bottom: 7px solid var(--otk-ui-tabs-tab-background-color);

    // core modules

    // -- delegations

    // ----  delegations-cargo-detail-header
    --delegations-cargo-detail-header-height: calc(var(--otk-theme-space-5xl) + calc(var(--otk-theme-space-s)/2));
    --delegations-cargo-detail-header-padding: 0px calc(var(--otk-theme-space-2xl) - calc(var(--otk-theme-space-s)/2)) 0px var(--otk-theme-space-l);

    // ---- delegations-cargos-actions-zip-codes-by-location-summary
    --delegations-cargos-actions-zip-codes-by-location-summary-padding-vertical: 13px;

    // ---- delegation-filters
    --delegations-cargos-filters-delegation-filter-padding: 10px;
  }
`;

// src/theme-provider.tsx
function ThemeProvider({
  theme,
  children
}) {
  const tenantThemeGlobalVariable = tenantsThemeGlobalVariables[theme];
  const BaseThemeGlobalVariables = createGlobalStyle`
    ${baseThemeGlobalVariables}
  `;
  const TenantThemeGlobalVariables = createGlobalStyle`
    ${tenantThemeGlobalVariable}
  `;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BaseThemeGlobalVariables, null), /* @__PURE__ */ React.createElement(TenantThemeGlobalVariables, null), children);
}
export {
  ThemeProvider,
  tenantsNames
};
